// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
require('custom/users')
require('custom/full_calendar')
// import * as ActiveStorage from "@rails/activestorage"
// import "channels"

import flatpickr from 'flatpickr'
import chosenjs from 'chosen-js'
import Spanish from 'flatpickr/dist/l10n/es.js'

require('flatpickr/dist/flatpickr.css')
require('flatpickr/dist/themes/airbnb.css')
require('chosen-js/chosen.css')

Rails.start()
Turbolinks.start()
// ActiveStorage.start()

document.addEventListener('turbolinks:load', () => {

	$("[data-form-prepend]").click(function(e) {
		var obj = $($(this).attr("data-form-prepend"));
		obj.find("input, select, textarea").each(function() {
			$(this).attr("name", function() {
				return $(this)
				.attr("name")
				.replace("new_record", new Date().getTime());
			});
		});
		obj.insertBefore(this);
		$('.chosen-select').chosen();
		return false;
	});

	var today = new Date()

	flatpickr("[data-behavior='flatpickr-from-today']", {
		altInput: true,
		altFormat: "j-M-Y",
		dateFormat: "Y-m-d",
		locale: "es",
		minDate: new Date()
	});

	flatpickr("[data-behavior='flatpickr-to-today']", {
		altInput: true,
		altFormat: "j-M-Y",
		dateFormat: "Y-m-d",
		locale: "es",
		maxDate: new Date()
	});

	flatpickr("[data-behavior='flatpickr-all']", {
		altInput: true,
		altFormat: "j-M-Y",
		dateFormat: "Y-m-d",
		locale: "es"
	});

	flatpickr("[data-behavior='datetimepickr-all']", {
		enableTime: true,
		altFormat: "j-M-Y",
		dateFormat: "Y-m-d H:i",
		locale: "es"
	});

	$('.chosen-select').chosen({
		allow_single_deselect: true,
		no_results_text: 'No se encontraron resultados',
		placeholder_text_single: 'Seleccione una opción...',
		placeholder_text_multiple: 'Seleccione una o varias opciones...',
		width: '100%'
	});

	$(".hamburger .fas").click(function() {
		$(".wrapper").addClass("active");
	});

	$(".wrapper .sidebar .close").click(function() {
		$(".wrapper").removeClass("active");
	});

	$(function () {
		$('[data-toggle="tooltip"]').tooltip({
			html: true
		});

		$("#timer-alert").fadeTo(3000, 500).slideUp(500, function(){
			$("#timer-alert").alert('close')
		});
	});

	$(function () {
		$('[data-toggle="popover"]').popover({
			placement : 'top',
			trigger : 'hover'
		})
	});

});